import { useState } from "react";
import axios from "axios";
import { API, formatApiErrorDetail } from "@/lib/api";

export const TOPICS = [
  "I'm looking for support or resources",
  "I'd like to volunteer",
  "I'd like to partner or be a vendor",
  "I have a question about donating",
  "Something else",
];
const EMPTY = { name: "", phone: "", email: "", topic: TOPICS[0], message: "" };

const validate = (f) => {
  const e = {};
  if (!f.name.trim()) e.name = "Please add your name.";
  if (!/^\S+@\S+\.\S+$/.test(f.email.trim())) e.email = "Please add a valid email.";
  if (f.phone.trim() && (!/^[0-9+()\-.\s]{7,40}$/.test(f.phone.trim()) || f.phone.replace(/\D/g, "").length < 7))
    e.phone = "Please add a valid phone number.";
  if (!f.message.trim()) e.message = "Please add a message.";
  return e;
};

export const ContactForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState({ type: "", text: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    const errs = validate(form);
    setErrors(errs);
    if (Object.keys(errs).length) {
      setStatus({ type: "err", text: "Add your name, a valid email, and a message so we can reply." });
      return;
    }
    setBusy(true);
    try {
      await axios.post(`${API}/contact`, form);
      setForm(EMPTY);
      setStatus({ type: "ok", text: "Thank you! Your message has been sent. We'll be in touch soon." });
    } catch (err) {
      setStatus({ type: "err", text: formatApiErrorDetail(err.response?.data?.detail) });
    } finally {
      setBusy(false);
    }
  };

  const err = (k) => errors[k] && <em className="field-err" data-testid={`contact-${k}-error`}>{errors[k]}</em>;

  return (
    <form className="contact-form" onSubmit={submit} noValidate data-testid="contact-form">
      <h3>Send us a message</h3>
      <div className="row">
        <label>Your name<input name="name" autoComplete="name" required value={form.name} onChange={set("name")} aria-invalid={!!errors.name} data-testid="contact-name-input" />{err("name")}</label>
        <label>Phone (optional)<input name="phone" type="tel" autoComplete="tel" value={form.phone} onChange={set("phone")} aria-invalid={!!errors.phone} data-testid="contact-phone-input" />{err("phone")}</label>
      </div>
      <label>Email<input name="email" type="email" autoComplete="email" required value={form.email} onChange={set("email")} aria-invalid={!!errors.email} data-testid="contact-email-input" />{err("email")}</label>
      <label>How can we help?
        <select name="topic" value={form.topic} onChange={set("topic")} data-testid="contact-topic-select">
          {TOPICS.map((t) => <option key={t}>{t}</option>)}
        </select>
      </label>
      <label>Message<textarea name="message" required value={form.message} onChange={set("message")} aria-invalid={!!errors.message} data-testid="contact-message-input" />{err("message")}</label>
      <button className="btn btn-purple" type="submit" disabled={busy} data-testid="contact-submit-button">{busy ? "Sending…" : "Send message"}</button>
      <p className={`form-msg ${status.type}`} role="status" data-testid="contact-form-status">{status.text}</p>
    </form>
  );
};
